// extracted by mini-css-extract-plugin
export default {"productGallery":"mL-z","inQuickShop":"nL-z"};